export const environment = {
  production: true,
  apiUrl: 'https://api.xedoom.com/api', // Replace with your production API URL
  chatUrl: 'https://api.xedoom.com/chat', // Replace with your production chat URL
  siteUrl: 'https://xedoom.com', // Replace with your production site URL
  wsUrl: 'wss://api.xedoom.com',
  googleClientId: '941571640455-t0llj7tohhccld9tuaj3qsk2bcjgh1so.apps.googleusercontent.com',
  cdnUrl: 'https://cdn.xedoom.com',
  debugLog: false,
  version: '0.90'
};
